module.exports = __webpack_public_path__ + "static/Chicory6-ca76ebcb99f72e2707ff2d388471f87e.png";